export default function PHP_cos() {
  return (
    <div>
      <h1>PHP_cos</h1>
    </div>
  );
}
